import './styles/Branding.scss';

import { CSSProperties } from 'react';

import { useClassHelper } from '../../../../hooks';
import { WebsheetTemplateProps } from '../../../../types';
import { TermsAndConditionsBase } from '../../components/TermsAndConditionsBase';
import { useGetStyles } from '../../hooks/useGetStyles';

const componentName = 'c-Branding';

export const Branding = (props: WebsheetTemplateProps) => {
  const c = useClassHelper(componentName);
  const {
    values,
    text: { content },
    isPortalPreview,
  } = props;

  const getStyles = useGetStyles({ values });

  return (
    <TermsAndConditionsBase
      getStyles={getStyles}
      isPortalPreview={isPortalPreview}
      styling={{
        logoUrl: values.logoUrl,
        title: {
          text: 'Title',
          fontFamily: values.fontTitle,
        },
        content: {
          text: content,
          valueFontParagraph: values.fontParagraph,
        },
      }}
      footer={
        <>
          <button
            className={c('__button')}
            style={
              {
                fontFamily: values.fontParagraph,
                background: values.colorButton,
                color: values.colorButtonText || '#fff',
                '--color-button-active': values.colorButtonClick,
              } as CSSProperties
            }
          >
            Button
          </button>
        </>
      }
    />
  );
};
